module.exports = __webpack_public_path__ + "img/svg.345ecdb7.png";